module.exports = __webpack_public_path__ + "static/media/imgop_calculator.585557e5.jp2";